import { AxiosResponse } from "axios";
import { get, routes } from "api";
import { IGetTasksRequestParams } from "models/tasks.models";

const tasks = {
  getTasks(
    params?: IGetTasksRequestParams,
    isMockApiOn?: boolean,
  ): Promise<AxiosResponse> {
    return get(routes.workflows.tasks.all(), {
      params,
      isMockApiOn,
    });
  },
};

export default tasks;
